import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationService } from '../organization.service';
import { Organization } from 'src/app/services/organization.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';  // Add FormBuilder and FormGroup
import { UserDataService } from 'src/app/services/user-data-service';

@Component({
    selector: 'app-organization-warning-dialog',
    templateUrl: './organization-warning-dialog.component.html',
    styleUrls: ['./organization-warning-dialog.component.css'],
    standalone: false
})
export class OrganizationWarningDialogComponent implements OnInit {

 dialogTitle: string;
  organizations: Organization[] = [];
  organizationForm: FormGroup;  // Define the FormGroup
  moduleType:string='';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,  // Inject FormBuilder
    private organizationService: OrganizationService,  // Inject OrganizationService
    private userDataService:UserDataService,
    private dialogRef: MatDialogRef<OrganizationWarningDialogComponent>
  ) {
    
   
  }

  ngOnInit(): void {
    // If needed, any additional initialization can go here
  }

  onSave(): void {
    this.dialogRef.close({ status: true });
  }

  onCancel(): void {
    this.dialogRef.close({ status: false });  // Close dialog without passing any data
  }
}